/** @jsx jsx */
import type { SerializedStyles } from '@emotion/react';

import { useState } from 'react';

import { fullScreenStyles } from './animationsStyles';

export default function useFullScreenAnimation() {
  const [fullScreenCSS, setFullScreenCSS] = useState<SerializedStyles[]>([]);

  function startFullScreenAnimation() {
    setFullScreenCSS([fullScreenStyles.fullScreen]);
  }

  function exitFullScreenAnimation() {
    setFullScreenCSS([fullScreenStyles.exitFullScreen]);
    setTimeout(() => {
      setFullScreenCSS([]);
    }, 350);
  }

  return { startFullScreenAnimation, exitFullScreenAnimation, fullScreenCSS };
}
